import React, { useEffect, useState } from "react";
import { Loader2, MousePointerClick, Eye, Percent, ArrowDownUp, FileText, Search, Globe2, Monitor } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { Kpi, Bars } from "@/components/admin/TrafficPanel";
import { Chart, DataTable, pathOf } from "./parts";

const COLS = [
  { label: "Clicks", num: true, get: (r) => r.clicks.toLocaleString() },
  { label: "Impressions", num: true, get: (r) => r.impressions.toLocaleString() },
  { label: "CTR", num: true, get: (r) => `${r.ctr}%` },
  { label: "Position", num: true, get: (r) => r.position },
];

export default function SearchConsolePanel({ days }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => {
    setD(null); setErr("");
    api.get("/admin/google/search", { params: { days } }).then((r) => setD(r.data)).catch((e) => setErr(formatApiError(e.response?.data?.detail)));
  }, [days]);
  if (err) return <p className="mt-4 text-sm text-amber-400" data-testid="gsc-error">{err}</p>;
  if (!d) return <Loader2 className="mt-6 animate-spin text-white/30" />;
  const t = d.totals;
  return (
    <div data-testid="gsc-panel">
      <p className="text-xs text-white/40 mt-2">{d.site_url} · {d.start} → {d.end} (Google data has ~2 days delay)</p>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 mt-3">
        <Kpi icon={MousePointerClick} label="Clicks from Google" value={t.clicks} testid="gsc-clicks" />
        <Kpi icon={Eye} label="Impressions" value={t.impressions} testid="gsc-impressions" />
        <Kpi icon={Percent} label="Average CTR" value={`${t.ctr}%`} testid="gsc-ctr" />
        <Kpi icon={ArrowDownUp} label="Average position" value={t.position} testid="gsc-position" />
      </div>
      <Chart data={d.daily} x="key" testid="gsc-chart" lines={[{ key: "clicks", name: "Clicks", color: "#4285F4" }, { key: "impressions", name: "Impressions", color: "#a78bfa" }]} />
      <DataTable title="Top pages in Google Search" icon={FileText} rows={d.pages} testid="gsc-pages" cols={[{ label: "Page", get: (r) => pathOf(r.key) }, ...COLS]} />
      <DataTable title="Top search queries" icon={Search} rows={d.queries} testid="gsc-queries" cols={[{ label: "Query", get: (r) => r.key }, ...COLS]} />
      <div className="grid md:grid-cols-2 gap-4 mt-4">
        <Bars title="Countries (clicks)" icon={Globe2} unit="clicks" testid="gsc-countries" items={d.countries.map((c) => ({ name: c.key.toUpperCase(), count: c.clicks }))} />
        <Bars title="Devices (clicks)" icon={Monitor} unit="clicks" testid="gsc-devices" items={d.devices.map((c) => ({ name: c.key.charAt(0) + c.key.slice(1).toLowerCase(), count: c.clicks }))} />
      </div>
    </div>
  );
}
